'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const mtMT = {
    el: {
        colorpicker: {
            confirm: 'Kollox sew',
            clear: 'Ċara'
        },
        datepicker: {
            now: 'Issa',
            today: 'Illum',
            cancel: 'Ikkanċella',
            clear: 'Ċara',
            confirm: 'Kollox sew',
            selectDate: 'Agħżel id-data',
            selectTime: 'Agħżel il-ħin',
            startDate: 'Data tal-Bidu',
            startTime: 'Ħin tal-Bidu',
            endDate: 'Data tat-Tmiem',
            endTime: 'Ħin tat-Tmiem',
            prevYear: 'Sena ta \'qabel',
            nextYear: 'Is-sena d-dieħla',
            prevMonth: 'Ix-Xahar ta ’Qabel',
            nextMonth: 'Ix-xahar id-diehel',
            year: 'sena',
            month1:  'Jannar',
            month2:  'Frar',
            month3:  'Marzu',
            month4:  'April',
            month5:  'Mejju',
            month6:  'Ġunju',
            month7:  'Lulju',
            month8:  'Awissu',
            month9:  'Settembru',
            month10: 'Ottubru',
            month11: 'Novembru',
            month12: 'Diċembru',
            week: 'ġimgħa',
            weeks: {
                sun: 'Ħad',
                mon: 'Tne',
                tue: 'Tli',
                wed: 'Erb',
                thu: 'Ħam',
                fri: 'Ġim',
                sat: 'Sib'
            },
            months: {
                jan: 'Jan',
                feb: 'Fra',
                mar: 'Mar',
                apr: 'Apr',
                may: 'Mej',
                jun: 'Ġun',
                jul: 'Lul',
                aug: 'Awi',
                sep: 'Set',
                oct: 'Ott',
                nov: 'Nov',
                dec: 'Diċ'
            }
        },
        select: {
            loading: 'Tagħbija',
            noMatch: 'L-ebda dejta li taqbel',
            noData: 'L-ebda dejta',
            placeholder: 'Agħżel'
        },
        cascader: {
            noMatch: 'L-ebda dejta li taqbel',
            loading: 'Tagħbija',
            placeholder: 'Agħżel',
            noData: 'L-ebda dejta'
        },
        pagination: {
            goto: 'Mur fuq',
            pagesize: '/ paġna',
            total: 'Total {total}',
            pageClassifier: ''
        },
        messagebox: {
            title: 'Messaġġ',
            confirm: 'kollox sew',
            cancel: 'Ikkanċella',
            error: 'Input mhux permess'
        },
        upload: {
            deleteTip: 'agħfas tħassar biex tneħħi',
            delete: 'Ħassar',
            preview: 'Preview',
            continue: 'Kompli'
        },
        table: {
            emptyText: 'L-ebda dejta',
            confirmFilter: 'Ikkonferma',
            resetFilter: 'Irrisettja',
            clearFilter: 'Kollha',
            sumText: 'Somma'
        },
        tree: {
            emptyText: 'L-ebda dejta'
        },
        transfer: {
            noMatch: 'L-ebda dejta li taqbel',
            noData: 'L-ebda dejta',
            titles: ['Lista 1', 'Lista 2'],
            filterPlaceholder: 'Daħħal kelma prinċipali',
            noCheckedFormat: '{total} oġġetti',
            hasCheckedFormat: '{checked}/{total} iċċekkjat'
        },
        image: {
            error: 'FALLAT'
        },
        pageHeader: {
            title: 'Lura'
        },
        popconfirm: {
            confirmButtonText: 'Iva',
            cancelButtonText: 'Le'
        }
    }
};

exports["default"] = mtMT;